import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatTimezoneAbbreviation',
})
export class FormatTimezoneAbbreviationPipe implements PipeTransform {
  transform(timezone: string): string {
    if (!timezone) {
      return '';
    }

    try {
      const date = new Date();
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: timezone.trim(),
        timeZoneName: 'short',
      });

      const parts = formatter.formatToParts(date);
      const abbreviation = parts.find(part => part.type === 'timeZoneName')?.value;

      return abbreviation ?? '';
    } catch (error) {
      console.error('Invalid timezone:', timezone, error);
      return '';
    }
  }
}
